import React, { useState } from 'react'

import { Upload, Button, message, Card, Progress, Spin, Space, Tag, Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import * as libCon from "../community-hats-js-library/Constants.js"
import * as locCon from "../LocalConstants.js"

import { filterObjectByFunction, isNullOrUndefined, sumArray } from '../community-hats-js-library/utils/generalFunctions.js';
import { extractPDFsFromZip } from '../community-hats-js-library/utils/labFunctions.js';
import { RefStoredValue } from '../hooks/GeneralStoreHooks.js';
import { DownloadFilesButton } from './LabResultsComponents.js';
import { RefContextLanguage } from '../providers/LanguageProvider';


function UploadLabResults({ pdfFiles, setPdfFiles, metadataForFiles, setMetadataForFiles, resetUploadProgress }) {

    const i18n = RefContextLanguage()

    const location = RefStoredValue(locCon.PROJECT_LOCATION)

    const participantStatus = RefStoredValue(libCon.STATUS_DATASET_PARTICIPANTS)

    const [isProcessing, setIsProcessing] = useState(false)
    const [processProgress, setProcessProgress] = useState(0)

    const [filesWithErrorArray, setFilesWithErrorArray] = useState([])
    const [duplicateCases, setDuplicateCases] = useState({})


    const [showSuccessfullRecords, setShowSuccessfullRecords] = useState(false)
    const [showDuplicateRecords, setShowDuplicateRecords] = useState(false)
    const [showErrorRecords, setShowErrorRecords] = useState(false)

    const [resultsFile, setResultsFileFile] = useState(null);


    // Function to handle file processing
    const processResultsFile = async () => {

        setProcessProgress(0)

        resetUploadProgress()

        await new Promise(resolve => setTimeout(resolve, 0)); // Let React update


        if (!resultsFile) {
            message.error(i18n.t('noFileSelected'));
            return;
        }

        if (participantStatus !== libCon.OK) {
            message.error(i18n.t('participantsNotLoaded'));
            return;
        }

        setIsProcessing(true)


        const fileBytes = await resultsFile.arrayBuffer();

        // Split the PDF
        let [pdfArray, metadataArray, errorFiles] = await extractPDFsFromZip(fileBytes, (per) => setProcessProgress(per * 0.95));


        // iterates 
        metadataArray = metadataArray.map((metadata, i) => {
            setProcessProgress(95 + (5 * i / metadataArray.length));

            // Adds location
            metadata[libCon.ATF_LOCATION] = location

            if (isNullOrUndefined(metadata[libCon.ATF_NAME]))
                return metadata

            return { ...metadata }

        })

        // converts to metadata dict
        let metadataDict = {}
        let pdfDicts = {}

        let duplicateFiles = {}

        metadataArray.forEach((metadata, i) => {

            const caseId = metadata[libCon.ATF_CASE_ID]
            const fileName = metadata[libCon.ATF_FILE_NAME]

            if (!(caseId in duplicateFiles))
                duplicateFiles[caseId] = []

            duplicateFiles[caseId].push(fileName)

            metadataDict[caseId] = metadata
            pdfDicts[caseId] = pdfArray[i]

        })


        setPdfFiles(pdfDicts);
        setMetadataForFiles(metadataDict)


        // Sets the records with error and duplicates
        setFilesWithErrorArray([...errorFiles])

        // Filters
        duplicateFiles = filterObjectByFunction(duplicateFiles, v => v.length > 1)

        setDuplicateCases({ ...duplicateFiles })


        setProcessProgress(100)
        setIsProcessing(false)
    };


    return (
        <div >
            {/* Processing Modals */}
            {/* Successfull records */}
            <Modal width={"70vw"}
                title={i18n.t('successfulRecords')}
                open={showSuccessfullRecords}
                onCancel={() => setShowSuccessfullRecords(false)}
                footer={<DownloadFilesButton
                    pdfFiles={pdfFiles}
                    metadataForFiles={metadataForFiles}
                    keys={isNullOrUndefined(metadataForFiles) ? [] : Object.keys(metadataForFiles)}
                    fileName={"imported_successfully.zip"} />}>
                {
                    !isNullOrUndefined(metadataForFiles)
                        ? Object.keys(metadataForFiles).map((key, i) => {
                            return (
                                <div key={i}>
                                    <p>{key}: {metadataForFiles[key][libCon.ATF_FILE_NAME]}</p>
                                </div>
                            )
                        }

                        )
                        : <div></div>
                }
            </Modal>

            {/* Duplicate records */}
            <Modal width={"70vw"} title={i18n.t('duplicateRecords')} open={showDuplicateRecords} onCancel={() => setShowDuplicateRecords(false)} footer={null}>
                {
                    !isNullOrUndefined(duplicateCases)
                        ? Object.keys(duplicateCases).map((key, i) => {
                            return (
                                <div style={{ marginBottom: "20px" }} key={i}>
                                    <p style={{ marginTop: "1px", marginBottom: "1px" }}>{key}: {duplicateCases[key].length} {i18n.t('times')}</p>
                                    {
                                        duplicateCases[key].map((file, j) => { return (<p style={{ marginLeft: "15px", marginTop: "1px", marginBottom: "1px" }} key={j}>{`   ${file}`}</p>) })
                                    }
                                </div>
                            )
                        }

                        )
                        : <div></div>
                }
            </Modal>


            {/* Error records */}
            <Modal title={i18n.t('errorRecords')} open={showErrorRecords} onCancel={() => setShowErrorRecords(false)} footer={null}>
                {
                    !isNullOrUndefined(filesWithErrorArray)
                        ? filesWithErrorArray.map((key, i) => {
                            return (
                                <div key={i}>
                                    <p>{key}</p>
                                </div>
                            )
                        }

                        )
                        : <div></div>
                }
            </Modal>

            <Card style={{ width: "40vw", marginTop: "10px" }}
                styles={{ header: { backgroundColor: "var(--primary-color-3)" } }}
                type="inner" size="medium" title={i18n.t('uploadLabResults')}>


                <Upload
                    beforeUpload={(uploadedFile) => {
                        setResultsFileFile(uploadedFile); // Store the uploaded file
                        message.success(`${i18n.t('labResultsUploaded')}: ${uploadedFile.name}`);
                        resetUploadProgress()
                        setProcessProgress(0)


                        return false; // Prevent automatic upload
                    }}
                    showUploadList={false} // Hide default file list
                >
                    <Button icon={<UploadOutlined />}>{i18n.t('clickToUpload')}</Button>
                </Upload>

                {!isNullOrUndefined(resultsFile)
                    ? <p style={{ marginTop: "10px" }}>{i18n.t('selectedFile')}: {resultsFile.name}</p>
                    : <div style={{ marginTop: "10px" }}></div>
                }

                {/* Process File Button */}
                {
                    isProcessing
                        ? <Spin />
                        : <Button
                            type="primary"
                            style={{ marginTop: "10px" }}
                            onClick={processResultsFile}
                        >
                            {i18n.t('processFile')}
                        </Button>
                }
                {
                    processProgress === 100
                        ? <div>
                            <p style={{ marginTop: "10px" }}>{i18n.t('totalFiles')}: {Object.keys(pdfFiles).length + filesWithErrorArray.length + sumArray(Object.values(duplicateCases).map(l => l.length - 1))} </p>
                            <Space direction="horizontal">
                                <Tag onClick={() => setShowSuccessfullRecords(true)} color="green" style={{ marginTop: "10px", fontSize: '16px', padding: '6px 12px' }}>{i18n.t('successful')}: {Object.keys(pdfFiles).length} </Tag>
                                <Tag onClick={() => setShowDuplicateRecords(true)} color="gold" style={{ marginTop: "10px", fontSize: '16px', padding: '6px 12px' }}>{i18n.t('duplicateCases')}: {sumArray(Object.values(duplicateCases).map(l => l.length - 1))}</Tag>
                                <Tag onClick={() => setShowErrorRecords(true)} color="red" style={{ marginTop: "10px", fontSize: '16px', padding: '6px 12px' }}>{i18n.t('filesWithErrors')}: {filesWithErrorArray.length}</Tag>
                            </Space>
                        </div>
                        : <div style={{ height: "30px" }}></div>
                }

                <Progress style={{ width: "100%" }} percent={processProgress} status='success' />


            </Card>
        </div>
    )
}

export default UploadLabResults